import type { IconSvgObject } from './types';

const RainDropIcon: IconSvgObject = [
  ["path", { d: "M3.5 13.678C3.5 9.49387 7.08079 5.35907 9.59413 2.97222C10.9591 1.67593 13.0409 1.67593 14.4059 2.97222C16.9192 5.35907 20.5 9.49387 20.5 13.678C20.5 17.7804 17.2812 22 12 22C6.71878 22 3.5 17.7804 3.5 13.678Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }]
];

export default RainDropIcon;
